export function clearWildcards(term?: string): string {
    return (term || '').replace(/[*$/\\"']/gi, '');
}
